/* The Black Friday signs catch once, then blink briefly on return; model names condense out of smoke.
   Owner, 23/10: slow living light in the film, chooser and BF 98 / BF 99 pages, also with reduced motion.
   Works with orion-neon.css and their data-orion-neon / data-orion-smoke-words elements. */
(() => {
  if (window.OrionNeon) { window.OrionNeon.init(document); return; }
  const states = new Map();
  const slides = new Map();
  const selector = '[data-orion-neon], [data-orion-smoke-words]';
  const letters = (node, prefix) => {
    const text = node.textContent.trim();
    const chars = Array.from(text);
    node.replaceChildren(...chars.map((char, index) => {
      // A line break of the hero sign (one word under the other, owner 23/10) stays a line break.
      if (char === '\n') return document.createElement('br');
      const span = document.createElement('span');
      span.className = `${prefix}__letter`;
      span.textContent = char;
      span.style.setProperty('--i', index);
      span.style.setProperty('--drift', `${(index - (chars.length - 1) / 2) * .055}em`);
      span.style.setProperty('--turn', `${index % 2 ? 4 : -4}deg`);
      return span;
    }));
    return chars.length;
  };
  const settle = state => state.words?.forEach((word, index) => {
    word.classList.remove('is-entering', 'is-leaving');
    word.classList.toggle('is-current', index === state.index);
  });
  const rotate = state => {
    if (!state.active || !state.node.isConnected) return;
    const previous = state.words[state.index];
    state.index = (state.index + 1) % state.words.length;
    const next = state.words[state.index];
    previous.classList.remove('is-current');
    previous.classList.add('is-leaving');
    next.classList.add('is-current', 'is-entering');
    state.timer = setTimeout(() => {
      settle(state);
      state.timer = setTimeout(() => rotate(state), 4000);
    }, 2050 + state.length * 45);
  };
  const update = state => {
    const slide = state.slide;
    const ready = !slide || slide.matches('.is-active:not([inert]):not([aria-hidden="true"])') &&
      (slide.hasAttribute('data-opening') || slide.hasAttribute('data-started') || slide.hasAttribute('data-seen') ||
       slide.hasAttribute('data-waiting') || slide.dataset.mode === 'manual' || slide.dataset.state === 'error');
    const active = state.inView && ready && !document.hidden && state.node.isConnected;
    if (state.active === active) return;
    state.active = active;
    clearTimeout(state.timer);
    if (state.words) {
      settle(state);
      if (active && state.words.length > 1) state.timer = setTimeout(() => rotate(state), 4000);
    } else if (active) {
      if (slide) state.node.style.setProperty('--neon-delay', slide.classList.contains('is-entering') ? '.5s' : '.12s');
      state.node.dataset.neonRun = state.seen ? 'return' : 'first';
      state.seen = true;
    } else {
      delete state.node.dataset.neonRun;
    }
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = states.get(entry.target);
      if (!state) return;
      state.inView = entry.isIntersecting;
      update(state);
    });
  }, { threshold: .05 }) : null;
  const init = root => {
    root.querySelectorAll(selector).forEach(node => {
      if (states.has(node)) return;
      const state = { node, slide: node.closest('[data-slide]'), inView: !observer, active: false, seen: false, index: 0 };
      if (node.hasAttribute('data-orion-smoke-words')) {
        state.words = [...node.querySelectorAll('.orion-smoke-words__word')];
        state.length = Math.max(0, ...state.words.map(word => letters(word, 'orion-smoke-words')));
      } else {
        const label_text = node.textContent.trim();
        // The hero sign stands one word under the other (owner 23/10: «η μία λέξη κάτω από την άλλη»).
        const text = node.classList.contains('orion-neon--hero') ? label_text.split(/\s+/).join('\n') : label_text;
        const label = document.createElement('span');
        label.className = 'visually-hidden';
        label.textContent = label_text;
        const tube = document.createElement('span');
        tube.className = 'orion-neon__tube';
        tube.setAttribute('aria-hidden', 'true');
        tube.dataset.neonText = text;
        tube.textContent = text;
        letters(tube, 'orion-neon');
        node.replaceChildren(label, tube);
      }
      states.set(node, state);
      if (state.slide && !slides.has(state.slide)) {
        const watcher = new MutationObserver(() => states.forEach(item => { if (item.slide === state.slide) update(item); }));
        watcher.observe(state.slide, { attributes: true, attributeFilter: ['class', 'inert', 'aria-hidden', 'data-opening', 'data-started', 'data-seen', 'data-waiting', 'data-mode', 'data-state'] });
        slides.set(state.slide, watcher);
      }
      if (observer) observer.observe(node);
      else update(state);
    });
  };
  // An easter egg in the description of BF 98 and BF 99 (owner 23/10: «θέλει κάποιο easter egg μέσα στην περιγραφή και
  // στα 2»), in the manner of the bed bases' τάβλες / λάτες (assets/orion-story.js): the word «Black» of the fabric
  // («Black 6A») reads as any other word; pressed, it lights up as the sign does and «Friday» condenses beside it out of
  // smoke, then both go quiet again. Only on a page with a Black Friday code sign (sections/orion-mattress-product.liquid).
  const egg = root => {
    if (!root.querySelector('.orion-buy__code.orion-neon')) return;
    const lead = root.querySelector('.orion-story__lead');
    if (!lead || lead.querySelector('.orion-bf-egg')) return;
    const walker = document.createTreeWalker(lead, NodeFilter.SHOW_TEXT);
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      const at = node.nodeValue.search(/\bBlack\b/);
      if (at < 0) continue;
      const word = node.splitText(at);
      word.splitText(5);
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'orion-bf-egg';
      button.setAttribute('aria-label', 'Black… Friday');
      button.innerHTML = '<span class="orion-bf-egg__word">Black</span><span class="orion-bf-egg__more" aria-hidden="true"></span>';
      const more = button.lastChild;
      more.textContent = ' Friday';
      letters(more, 'orion-smoke-words');
      button.addEventListener('click', () => {
        clearTimeout(button._quiet);
        clearTimeout(button._gone);
        button.classList.remove('is-lit', 'is-fading');
        void button.offsetWidth;
        button.classList.add('is-lit');
        // «Friday» goes back into smoke, then the word is a word again.
        button._quiet = setTimeout(() => {
          button.classList.add('is-fading');
          button._gone = setTimeout(() => button.classList.remove('is-lit', 'is-fading'), 1500);
        }, 4200);
      });
      word.replaceWith(button);
      return;
    }
  };
  // The scents of the essential-oil pillows, in the same manner (owner 29/10: «τα αρώματα αν κάνει κάποιος κλικ πάνω
  // στην αγγλική λέξη είτε σε ελληνικά είτε αγγλικά τότε μεταφράζει μόνο με εφέ όπως τα black friday easter egg»): the
  // English name (Vetiver …), in the title (snippets/orion-product-refresh.liquid) and in the description, reads as any
  // other word; pressed, it catches the light as «Black» does, goes into smoke, and its Greek name condenses out of the
  // smoke in its place; a little later the Greek name goes back into smoke and the English one returns.
  const scentWord = button => {
    if (button._scent) return;
    button._scent = true;
    const from = button.textContent.trim(), to = button.dataset.other;
    button.setAttribute('aria-label', `${from} (${to})`);
    button.innerHTML = '<span class="orion-scent-egg__word orion-scent-egg__word--from"></span><span class="orion-scent-egg__word orion-scent-egg__word--to" aria-hidden="true"></span>';
    button.firstChild.textContent = from;
    button.lastChild.textContent = to;
    letters(button.firstChild, 'orion-smoke-words');
    letters(button.lastChild, 'orion-smoke-words');
    const phase = name => { button.classList.remove('is-lit', 'is-turned', 'is-back'); if (name) button.classList.add(name); };
    button.addEventListener('click', event => {
      event.preventDefault();
      button._timers?.forEach(clearTimeout);
      phase('');
      void button.offsetWidth;
      phase('is-lit');
      button._timers = [
        setTimeout(() => phase('is-turned'), 1000),
        setTimeout(() => phase('is-back'), 5200),
        setTimeout(() => phase(''), 7400)
      ];
    });
  };
  const scents = root => {
    const title = root.querySelector('[data-orion-scent]');
    if (!title) return;
    // Every scent of the series named in the description (the pillow's own and the other three) becomes the same word.
    const NAMES = { Vetiver: 'Βετιβέρ', Lavender: 'Λεβάντα', Eucalyptus: 'Ευκάλυπτος', 'Tea Tree': 'Τεϊόδεντρο' };
    NAMES[title.dataset.orionScent] = title.dataset.orionScentOther;
    const pattern = new RegExp(`\\b(${Object.keys(NAMES).join('|')})\\b`);
    root.querySelectorAll('.orion-story').forEach(story => {
      const walker = document.createTreeWalker(story, NodeFilter.SHOW_TEXT, { acceptNode: node => (node.parentElement.closest('button, a, h1, h2, h3, h4, h5, h6, .orion-scent-egg') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT) });
      const found = [];
      for (let node = walker.nextNode(); node; node = walker.nextNode()) if (pattern.test(node.nodeValue)) found.push(node);
      found.forEach(node => {
        let rest = node;
        for (let match = rest.nodeValue.match(pattern); match; match = rest.nodeValue.match(pattern)) {
          const hit = rest.splitText(match.index);
          rest = hit.splitText(match[1].length);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'orion-scent-egg';
          button.dataset.other = NAMES[match[1]];
          button.textContent = match[1];
          hit.replaceWith(button);
        }
      });
    });
    root.querySelectorAll('.orion-scent-egg').forEach(scentWord);
  };
  window.OrionNeon = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { init(document); egg(document); scents(document); }, { once: true });
  else { init(document); egg(document); scents(document); }
  document.addEventListener('visibilitychange', () => states.forEach(update));
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    states.forEach((state, node) => {
      if (!event.target.contains(node)) return;
      clearTimeout(state.timer);
      observer?.unobserve(node);
      states.delete(node);
    });
    slides.forEach((watcher, slide) => {
      if (!event.target.contains(slide)) return;
      watcher.disconnect();
      slides.delete(slide);
    });
  });
})();
